import { useEffect } from 'react';

export default function PageMetadata({ title, description, url, structuredData }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const restore = [];
    const update = (selector, tag, attributes, valueAttribute, value) => {
      const existing = document.head.querySelector(selector);
      const element = existing || document.createElement(tag);
      const previous = element.getAttribute(valueAttribute);
      Object.entries(attributes).forEach(([key, item]) => element.setAttribute(key, item));
      element.setAttribute(valueAttribute, value);
      if (!existing) document.head.appendChild(element);
      restore.push(() => {
        if (!existing) element.remove();
        else if (previous === null) element.removeAttribute(valueAttribute);
        else element.setAttribute(valueAttribute, previous);
      });
    };
    [
      ['name', 'description', description],
      ['property', 'og:title', title],
      ['property', 'og:description', description],
      ['property', 'og:url', url],
      ['name', 'twitter:title', title],
      ['name', 'twitter:description', description],
      ['name', 'twitter:url', url],
    ].forEach(([attribute, key, value]) => {
      update(`meta[${attribute}="${key}"]`, 'meta', { [attribute]: key }, 'content', value);
    });
    update('link[rel="canonical"]', 'link', { rel: 'canonical' }, 'href', url);
    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify(structuredData);
    document.head.appendChild(schema);
    return () => {
      document.title = previousTitle;
      restore.forEach((reset) => reset());
      schema.remove();
    };
  }, [title, description, url, structuredData]);

  return null;
}
